module.exports = __webpack_public_path__ + "img/rec-16.eb178a15.jpg";